import { render } from "./ListTable.vue?vue&type=template&id=22a775fd&scoped=true&ts=true"
import script from "./ListTable.vue?vue&type=script&lang=ts"
export * from "./ListTable.vue?vue&type=script&lang=ts"

import "./ListTable.vue?vue&type=style&index=0&id=22a775fd&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-sakakibara\\Documents\\Git\\workflow-system\\workflow\\frontend\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a775fd"]])

export default __exports__